export default __webpack_public_path__ + "static/media/background.6e49ff3e.jpg";